import React from "react";

import AccountingContent from "../components/payments-linking/accounting";

const Accounting = () => {
  return <AccountingContent />;
};

export default Accounting;
